var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1782_38045)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 78,
    height: 78,
    rx: 20,
    fill: "#F0CA43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.332 40.334H49.6654C48.2509 40.334 46.8943 40.8959 45.8941 41.8961C44.8939 42.8963 44.332 44.2528 44.332 45.6673V55.0007C44.332 55.3543 44.4725 55.6934 44.7226 55.9435C44.9726 56.1935 45.3117 56.334 45.6654 56.334H52.332V68.334C52.3314 68.589 52.4039 68.8389 52.541 69.0539C52.6781 69.269 52.8739 69.4402 53.1054 69.5473C53.3373 69.6541 53.5951 69.692 53.848 69.6566C54.1009 69.6211 54.3384 69.5138 54.532 69.3473L58.332 66.094L62.132 69.3473C62.3735 69.5539 62.6809 69.6674 62.9987 69.6674C63.3165 69.6674 63.6239 69.5539 63.8654 69.3473L67.6654 66.094L71.4654 69.3473C71.7069 69.5539 72.0142 69.6673 72.332 69.6673C72.5249 69.666 72.7155 69.6251 72.892 69.5473C73.1235 69.4402 73.3193 69.269 73.4564 69.0539C73.5935 68.8389 73.666 68.589 73.6654 68.334V45.6673C73.6654 44.2528 73.1035 42.8963 72.1033 41.8961C71.1031 40.8959 69.7465 40.334 68.332 40.334ZM46.9987 53.6673V45.6673C46.9987 44.9601 47.2796 44.2818 47.7797 43.7817C48.2798 43.2816 48.9581 43.0007 49.6654 43.0007C50.3726 43.0007 51.0509 43.2816 51.551 43.7817C52.0511 44.2818 52.332 44.9601 52.332 45.6673V53.6673H46.9987ZM70.9987 65.4407L68.532 63.3207C68.2905 63.1141 67.9832 63.0006 67.6654 63.0006C67.3476 63.0006 67.0402 63.1141 66.7987 63.3207L62.9987 66.574L59.1987 63.3207C58.9572 63.1141 58.6498 63.0006 58.332 63.0006C58.0142 63.0006 57.7069 63.1141 57.4654 63.3207L54.9987 65.4407V45.6673C54.997 44.7306 54.7487 43.8109 54.2787 43.0007H68.332C69.0393 43.0007 69.7176 43.2816 70.2176 43.7817C70.7177 44.2818 70.9987 44.9601 70.9987 45.6673V65.4407ZM68.332 47.0007C68.332 47.3543 68.1916 47.6934 67.9415 47.9435C67.6915 48.1935 67.3523 48.334 66.9987 48.334H58.9987C58.6451 48.334 58.3059 48.1935 58.0559 47.9435C57.8058 47.6934 57.6654 47.3543 57.6654 47.0007C57.6654 46.647 57.8058 46.3079 58.0559 46.0578C58.3059 45.8078 58.6451 45.6673 58.9987 45.6673H66.9987C67.3523 45.6673 67.6915 45.8078 67.9415 46.0578C68.1916 46.3079 68.332 46.647 68.332 47.0007ZM68.332 52.334C68.332 52.6876 68.1916 53.0267 67.9415 53.2768C67.6915 53.5268 67.3523 53.6673 66.9987 53.6673H58.9987C58.6451 53.6673 58.3059 53.5268 58.0559 53.2768C57.8058 53.0267 57.6654 52.6876 57.6654 52.334C57.6654 51.9804 57.8058 51.6412 58.0559 51.3912C58.3059 51.1411 58.6451 51.0007 58.9987 51.0007H66.9987C67.3523 51.0007 67.6915 51.1411 67.9415 51.3912C68.1916 51.6412 68.332 51.9804 68.332 52.334ZM68.332 57.6673C68.332 58.0209 68.1916 58.3601 67.9415 58.6101C67.6915 58.8602 67.3523 59.0007 66.9987 59.0007H58.9987C58.6451 59.0007 58.3059 58.8602 58.0559 58.6101C57.8058 58.3601 57.6654 58.0209 57.6654 57.6673C57.6654 57.3137 57.8058 56.9746 58.0559 56.7245C58.3059 56.4745 58.6451 56.334 58.9987 56.334H66.9987C67.3523 56.334 67.6915 56.4745 67.9415 56.7245C68.1916 56.9746 68.332 57.3137 68.332 57.6673Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1782_38045",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368542 0 0 0 0 0.519173 0 0 0 0 0.7625 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1782_38045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1782_38045",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTickets);
export default __webpack_public_path__ + "static/media/total_tickets.f87cb49c475bde605fd7f01932331aab.svg";
export { ForwardRef as ReactComponent };